module.exports = __webpack_public_path__ + "static/media/Six-Caps.ffe42099.svg";